import { Command } from 'commander';
import { GenerateDependencyCommand } from './generateDependencyCommand';

export function DependenciesCommand(): Command {
  const cmd = new Command('dependency');
  cmd.alias('d').description('Dependency related commands.');

  cmd.addCommand(GenerateDependencyCommand());
  return cmd;
}
